var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"text-center"},[_c('v-col',{attrs:{"cols":"12"}},[_c('HeadMetadata',{attrs:{"title":_vm.pageTitle}}),_c('NotFoundComponent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }